import { IsOptional, IsString } from 'class-validator';

export class StandardResponseDto {
  @IsOptional()
  @IsString()
  Status?: string;

  @IsOptional()
  @IsString()
  Message?: string;

  @IsOptional()
  @IsString()
  Message_code?: string;
  
  constructor(options?: Partial<StandardResponseDto>) {
    this.Status = options?.Status;
    this.Message = options?.Message;
    this.Message_code = options?.Message_code;
  }
}